export const GROW_GUIDE_USER_GUIDE_EXPERIMENT_KEY = 'coac-0003';